module.exports = __webpack_public_path__ + "img/premier-web__final-design.21093576.jpg";